import { Loader2, Lock } from "lucide-react";
import { cn } from "@/utils/stylesUtils";
import ToggleSwitch from "./ToggleSwitch";
import ActiveRestrictionDetails from "./ActiveRestrictionDetails";

export default function AccessControlCard({
  scope,
  isRestricted,
  restriction,
  districtRestriction,
  isLockedByDistrict,
  isLoading,
  isError,
  isRevoking,
  toggleLabel,
  toggleHint,
  onToggle,
  onEdit,
  onRevoke,
  onCreateSchoolRule,
}) {
  const showRestriction = isRestricted || isLockedByDistrict;

  return (
    <div className="border border-[#DDDDDD] rounded p-3 flex flex-col gap-2">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col gap-0.5">
          <span className="text-[16px] font-bold">{toggleLabel}</span>
          <span
            className={cn(
              "text-[16px] opacity-50",
              isLockedByDistrict && "text-amber-600 opacity-100",
            )}
          >
            {isLockedByDistrict ? (
              <span className="inline-flex items-center gap-1 text-amber-600">
                <Lock className="w-3 h-3 shrink-0" />
                The app is temporarily turned OFF for students. To turn it back
                on, please make sure the settings at the school and district
                level are set to “on”
              </span>
            ) : (
              toggleHint
            )}
          </span>
        </div>
        <ToggleSwitch
          id="access-toggle"
          checked={!isRestricted}
          onChange={onToggle}
          disabled={isLoading || isRevoking}
        />
      </div>
      <div className="h-px bg-[#DDDDDD]" />
      {isLoading ? (
        <div className="flex justify-center py-4">
          <Loader2 className="w-4 h-4 text-gray-400 animate-spin" />
        </div>
      ) : isError ? (
        <p className="text-[16px] opacity-50 text-center py-2">
          Failed to load access policy.{" "}
          <button
            className="underline opacity-100 text-[#3286DA]"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </p>
      ) : showRestriction ? (
        <ActiveRestrictionDetails
          scope={scope}
          restriction={restriction}
          districtRestriction={districtRestriction}
          isLockedByDistrict={isLockedByDistrict}
          isRevoking={isRevoking}
          onEdit={onEdit}
          onRevoke={onRevoke}
          onCreateSchoolRule={onCreateSchoolRule}
        />
      ) : (
        <p className="text-[16px] opacity-50 text-center py-2">
          No active pause.{" "}
          <span className="opacity-100 text-gray-600">
            Toggle off to schedule one.
          </span>
        </p>
      )}
    </div>
  );
}
